import React, { Component } from "react";
import moment from "moment";

export default class ParticipantInfo extends Component {
  actionStatusTitle = {
    0: "Request",
    1: "Check",
    2: "Verify",
    22: "Approve",
    5: "ReferBack",
  };

  Text(text, extraLabel) {
    return (
      <div>
        <label>{text}</label>
        {extraLabel}
      </div>
    );
  }

  render() {
    const participant = this.props.participant;
    const isRejectingOfficer = this.props.isRejectingOfficer;
    return (
      <div className="col-md-2">
        {this.Text(
          this.actionStatusTitle[this.props.actionStatus],
          isRejectingOfficer ? <label>[Rejected]</label> : null
        )}
        {this.Text(participant ? participant.fullname : "-")}
        {this.Text(participant ? participant.employment_id : "-")}
        {this.Text(participant ? participant.designation : "-")}
        {this.Text(participant ? participant.branch_name : "-")}
        {this.Text(
          participant && moment(participant.date_time).isValid()
            ? moment
                .parseZone(participant.date_time)
                .format("YYYY-MM-DD HH:mm:ss")
            : "-"
        )}
        {this.Text(participant ? participant.comment : "-")}
      </div>
    );
  }
}
